export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-foot-f958a89c6104bc5d6cbf54c8ab292461.svg";